import React, { useEffect, useState } from 'react';

import moment from 'moment';
// import { CKEditor } from 'ckeditor4-react';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';

const CommentSection = ({ internalComments, openComment }) => {

    const renderUrg = (code) => {
        let urg = '';
        let ucl = '';
        if(code == "0"){
            urg = 'Low';
            ucl = 'urg-low';
        }else if(code == "1"){
            urg = 'Normal';
            ucl = 'urg-nor';
        }else if(code == "2"){
            urg = 'Medium';
            ucl = 'urg-medi';
        }else if(code == "3"){
            urg = 'High';
            ucl = 'urg-hgh';
        }else if(code == "4"){
            urg = 'Very High';
            ucl = 'urg-vhgh';
        }

        return(<td><span className={`urgency ${ucl}`}>{urg}</span></td>);
    }
    
    const renderStat = (stat) => {
        let st = '';
        let cl = '';
        if(stat == "-1"){
            st = 'All';
            cl = 'signal-info';
        }else if(stat == "-1"){
            st = 'Open';
            cl = 'signal-info';
        }else if(stat == "0"){
            st = 'Unattended';
            cl = 'signal-unatd';
        }else if(stat == "1"){
            st = 'Closed';
            cl = 'signal-close';
        }else if(stat == "2"){
            st = 'In progress';
            cl = 'signal-inpro';
        }else if(stat == "3"){
            st = 'Taken';
            cl = 'signal-gray';
        }else if(stat == "4"){
            st = 'Forwarded';
            cl = 'signal-gray';
        }

        return(<td><span className={`signal status-signal ${cl}`}> </span>{st}</td>);
    }

    const renderDate = (date) => {

        let renderdate = '';
        let inComeDate = moment(date).format("D-MMM-YYYY");
        let dateNow = moment(Date.now()).format("D-MMM-YYYY");

        if(dateNow === inComeDate){
            renderdate = moment(date).format("HH:mm");
        }else{
            renderdate = moment(date).format("D/MMM/YYYY, HH:mm");
        }
        
        return ( <b><a href="#">{renderdate}</a></b> );
    }
    
    const renderComm = (data, cindx) => {

        let wordCount = 0;
        let regex = /(<([^>]+)>)/ig
        let result = data.replace(regex, '');

        const arr = result.split(' ');
        wordCount = arr.filter(word => word !== '').length;

        return(
            <>
                <span id={`comment-${cindx}`}>{result}</span>
                {wordCount > 20 ? 
                    <button 
                        id={`comment-more-btn-${cindx}`}
                        className="btn btn-sm text-right" 
                        onClick={(e) => showMore(e, cindx)}
                    >
                        <img src="newDesigning/images/down-arrow-black.svg" alt="down-arrow" />
                    </button>
                : ""}
            </>
        );
    }

    const showMore = (e, i) => {
        document.getElementById(`comment-${i}`).style.cssText += "display : block !important";
        document.getElementById(`comment-more-btn-${i}`).style.cssText += "display : none !important";
        document.getElementById(`comment-less-btn-${i}`).style.cssText += "display : block !important";
    }
    
    /*const showLess = (e, i) => {
        document.getElementById(`comment-${i}`).style.cssText += "display : -webkit-box !important";
        document.getElementById(`comment-less-btn-${i}`).style.cssText += "display : none !important";
        document.getElementById(`comment-more-btn-${i}`).style.cssText += "display : block !important";
    }*/

    return(
        <table  className="table">
            <thead>
                <tr>
                    <Trans><th>Date</th></Trans>
                    <Trans><th>Subject</th></Trans>
                    <Trans><th>From</th></Trans>
                    <Trans><th>To</th></Trans>
                    <Trans><th>Status</th></Trans>
                    <Trans><th>Urgency</th></Trans>
                    <Trans><th>Action</th></Trans>
                </tr>
            </thead>
            <tbody>
                {
                    internalComments?.map((comment, cindx) => {

                        let newClss = '';
            
                        if(cindx % 2 == 0){
                            newClss = 'evn-class';
                        }else{
                            newClss = 'odd-class';
                        }
            
                        return(
                            <>
                                <tr key={cindx} className={newClss}>
                                    <td>{ renderDate(comment.comment_date) }</td>
                                    <td>{comment.subject}</td>
                                    <td>{comment.user_name}</td>
                                    <td>{comment.to_user_name}</td>
                                    { renderStat(comment.status) }
                                    { renderUrg(comment.urgency_id) }
                                    <td>
                                        {comment.status == '3' || comment.status == '4' ? "" :
                                            <a className="comment-edit" onClick={(e) => openComment(e, comment)}><i className="fa fa-edit"></i></a>                                     
                                        }
                                    </td>
                                </tr>
                                <tr key={'t'+cindx} className={newClss}>
                                    <td colSpan="7">
                                        <div className="comment-box">                                    
                                            {renderComm(comment.comment_text, cindx)}
                                            
                                            {/* <button 
                                                id={`comment-less-btn-${cindx}`}
                                                className="btn btn-sm text-right" 
                                                style={{display: 'none'}}
                                                onClick={(e) => showLess(e, cindx)}
                                            >
                                                <Trans>Show Less</Trans>
                                            </button> */}
                                        </div>
                                    </td>
                                </tr>
                            </>
            
                        );
                    })
                }
            </tbody>
        </table>
    );

}

export default withTranslation()(CommentSection);